import src from "IMAGE";
export default { src, width: 284, height: 70, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAMklEQVR42k3KqxEAIAwE0bRCL2gUjo9C0H8Dl81MRMS7M2uSDi4mFh4aLMQMbPT8XwMHzPkzkyrOlfMAAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 2 }
